import React from 'react';
import { Link } from 'react-router-dom';
import usePageMeta from '../hooks/usePageMeta';
import './Reviews.css';

const reviews = [
  { name: 'Harley Trudeau', role: 'Google Review', text: 'Susan is amazing! Our company always goes to her for custom clothing, towels, bags, little trucks, and more. If you need anything customized, this is the place to go. Her work is always top-quality!', rating: 5 },
  { name: 'Alton Lenz', role: 'Google Review', text: 'One of the best places to get shirts and gear made quick and great work by Susan and team.', rating: 5 },
  { name: 'Alicia Arredondo', role: 'Google Review', text: "I'm very happy with the service... nice people and very nice products.", rating: 5 },
  { name: 'Stephanie Grusenmeyer', role: 'Google Review', text: 'We have been using Heaven Sent Promotions for over a year and we love the products we get back. They are quick, friendly, and so accommodating with your printing needs. We highly recommend using this company if you need promotional items in the Bexar County area.', rating: 5 },
  { name: 'Just In Time', role: 'Google Review', text: "Susan and her team have provided exceptional service for multiple start-up companies that I have been involved with. I exclusively use and recommend Heaven Sent Promotions for all of your branding needs. They embroider my laptop bags, Carhartt jackets for field staff, and Polos for the sales team. Susan's design team created my logo and made the process of re-branding manageable even with all of the changes I made. I'd give 10 STARS if I could!", rating: 5 },
  { name: 'Faith Kane', role: 'Google Review', text: 'I just picked up three pieces I dropped off for some embroidery. It all came out great and everyone I dealt with throughout the process was super nice. I will definitely be back for more embroidery work in the future!', rating: 5 },
  { name: 'B Ramos', role: 'Google Review', text: 'Susan is the best. She always takes care of shirts, hats, koozies, EVERYTHING for my restaurants. Highly recommend!', rating: 5 },
  { name: 'Marie', role: 'Google Review', text: "Heaven Sent made some t-shirts for my son's Life Celebration in November 2019 and they were perfect. For his 21st Heavenly birthday this year they made 70 shirts for me and they were amazing as well. Susan and her team were so wonderful to work with and kind. They were patient and understanding with the changes in the quantity. I highly recommend them to anyone who wants high-quality workmanship. So blessed to have found them.", rating: 5 },
];

function Reviews() {
  usePageMeta({
    title: 'Customer Reviews',
    description: 'See what San Antonio businesses, schools, and organizations say about working with Heaven Sent for custom apparel, embroidery, and promotional product needs. 4.7-star rated.',
    path: '/reviews',
  });

  return (
    <main className="reviews-page">
      <section
        className="page-hero"
        style={{
          backgroundImage:
            "linear-gradient(135deg, rgba(20, 12, 16, 0.55) 0%, rgba(40, 18, 28, 0.35) 60%, rgba(60, 25, 40, 0.45) 100%), url('/images/reviews-banner.jpg')",
        }}
      >
        <h1 className="script-font">Customer Reviews</h1>
        <p>See what our customers have to say</p>
      </section>

      <section className="reviews-section">
        <div className="reviews-grid">
          {reviews.map((r, i) => (
            <div key={i} className="review-card">
              <div className="review-header">
                <div className="review-avatar">{r.name[0]}</div>
                <div>
                  <strong>{r.name}</strong>
                  <span>{r.role}</span>
                </div>
              </div>
              <div className="stars">{'★'.repeat(r.rating)}{'☆'.repeat(5 - r.rating)}</div>
              <p>"{r.text}"</p>
            </div>
          ))}
        </div>

        <div className="reviews-cta">
          <h2 className="script-font">Ready to Experience It Yourself?</h2>
          <p>Join hundreds of satisfied customers.</p>
          <Link to="/quote" className="btn-pink">Get a Quote</Link>
        </div>
      </section>
    </main>
  );
}

export default Reviews;
